import { useCallback, useState } from "react";
import FilterDropdown from "../pages/GlobalSearch/components/FilterDropdown";

interface SingleSelectDropdownProps {
  label: string;
  options: { value: string; label: string }[];
  value: string | null;
  onChange: (value: string) => void;
  dropdownWidth?: string;
}

// Single-choice variant of FilterDropdown (same button and option styling),
// used for the invite modal's Role fields. Picking an option selects it and
// closes the menu; the button then shows the option's label.
const SingleSelectDropdown = ({
  label,
  options,
  value,
  onChange,
  dropdownWidth = "w-60",
}: SingleSelectDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = useCallback(() => setIsOpen((open) => !open), []);

  return (
    <FilterDropdown
      label={label}
      options={options}
      selectedValues={value ? [value] : []}
      onToggle={(selected) => {
        onChange(selected);
        setIsOpen(false);
      }}
      onClearAll={() => undefined}
      dropdownWidth={dropdownWidth}
      maxHeightClass="max-h-80"
      isOpen={isOpen}
      onToggleOpen={toggleOpen}
    />
  );
};

export default SingleSelectDropdown;
